import { catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { apiURL, reformatDate, Utilities } from '@approot/utilities';
import { EMPTY, Observable, map, switchMap } from 'rxjs';
import { AlertsService, AuthService } from '..';
import { GenericLeg, RfqSetup } from '@approot/models';

export interface BlotterState {
  rows: BlotterRow[];
  fromDate: string;
  lastUpdatedAt: Date;
}

export interface BlotterRow {
  timestampISO: string;
  requestId: number;
  accountName: string;
  email: string;
  date: string;
  cross: string;
  data: {
    hydra: {
      hedges: any[];
      legs: GenericLeg[];
      setup: RfqSetup;
    };
  };
}
@Injectable({
  providedIn: 'root'
})
export class BlotterService {
  public readonly blotterState = signal<BlotterState>({
    lastUpdatedAt: null,
    fromDate: reformatDate(new Date(), 'D MMM YYYY'),
    rows: []
  });
  private authService = inject(AuthService);
  private http = inject(HttpClient);
  private alertsService = inject(AlertsService);

  public getRfq(fromDate: string): Observable<BlotterRow[]> {
    return this.authService.currentSession$().pipe(
      switchMap(cognito => {
        return this.http
          .post<{ response: BlotterRow[] }>(
            apiURL('/fx/getRfqs'),
            { fromDate, timezone: Utilities.currentTimezone },
            this.getHeaders(cognito.getIdToken().getJwtToken())
          )
          .pipe(
            map(resp => resp.response),
            catchError(e => {
              raygunError(e, `/fx/getRfqs`, []);
              this.alertOnGetRfqError(e);
              return EMPTY;
            })
          );
      })
    );
  }

  private alertOnGetRfqError(m: any): void {
    this.alertsService.addAlert({
      message: m.message || 'Unable to load the blotter'
    });
  }

  private getHeaders(token: string): {
    headers: HttpHeaders;
  } {
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', token);
    return { headers };
  }
}
function raygunError(err: any, arg1: string, arg2: any[]) {
  throw new Error('Function not implemented.');
}
